import React, {useCallback} from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {MODE_CREATE, MODE_EDIT} from "../../../../codes";
import Editor from "../../../../common/Editor";
import ColorBox from "../../../../common/ColorBox";
import useCategoryEditor from "./useCategoryEditor";
import {IconPicker} from "../../../../common/IconPicker";
import {Checkbox} from "../../../../common/Checkbox";
import {AppModal, DeleteModal} from "../../../../common/AppModal";
import useProject from "../../../../util/useProject";

export const CategoryEditor = () => {
  const {
    show,
    t,
    mode,
    hideCategoryEditor,
    editedCategory,
    updateEditedCategory,
    submit,
    deleteConfirmationModal,
    showDeleteConfirmationModal,
    hideDeleteConfirmationModal,
    deleteWarningModal,
    deleteWarningModalMessage,
    hideDeleteWarningModal,
    onDeleteCategory
  } = useCategoryEditor();

  const {runWithExpiration} = useProject();

  return <Editor
    show={show}
    title={t(mode === MODE_CREATE ? "category_editor_title_add" : "category_editor_title_edit")}
    onShow={useCallback(() => document.getElementById("category-editor-name").focus(), [])}
    onSubmit={runWithExpiration(submit)}
    onCancel={hideCategoryEditor}
    onDelete={mode === MODE_EDIT ? runWithExpiration(showDeleteConfirmationModal) : null}
    submitLabel={t("category_editor_button_save")}
    cancelLabel={t("category_editor_button_cancel")}
  >
    <Form.Group as={Row} className="mb-2" controlId="category-editor-name">
      <Form.Label column sm={3}>{t("category_editor_field_name")}</Form.Label>
      <Col sm={9}>
        <Form.Control
          type="text"
          value={editedCategory.name}
          onChange={updateEditedCategory("name")}
          maxLength="50"
          isInvalid={editedCategory.errors.name}
        />

        <Form.Control.Feedback type="invalid">{t(editedCategory.errors.name)}</Form.Control.Feedback>
      </Col>
    </Form.Group>

    <Form.Group as={Row} className="mb-2" controlId="category-editor-group-name">
      <Form.Label column sm={3}>{t("category_editor_field_group_name")}</Form.Label>
      <Col sm={9}>
        <Form.Control
          type="text"
          value={editedCategory.groupName}
          onChange={updateEditedCategory("groupName")}
          maxLength="50"
          isInvalid={editedCategory.errors.groupName}
        />

        <Form.Control.Feedback type="invalid">{t(editedCategory.errors.groupName)}</Form.Control.Feedback>
      </Col>
    </Form.Group>

    <Form.Group as={Row} className="mb-2" controlId="category-editor-description">
      <Form.Label column sm={3}>{t("category_editor_field_description")}</Form.Label>
      <Col sm={9}>
        <Form.Control
          type="text"
          value={editedCategory.description}
          onChange={updateEditedCategory("description")}
          maxLength="100"
        />
      </Col>
    </Form.Group>

    <Form.Group as={Row} className="mb-2" controlId="category-editor-color">
      <Form.Label column sm={3}>{t("category_editor_field_color")}</Form.Label>
      <Col sm={9}>
        <ColorBox value={editedCategory.color} onChange={updateEditedCategory("color")}/>
      </Col>
    </Form.Group>

    <Form.Group as={Row} className="mb-2" controlId="category-editor-icon">
      <Form.Label column sm={3}>{t("category_editor_field_icon")}</Form.Label>
      <Col sm={9}>
        <IconPicker value={editedCategory.icon} onChange={updateEditedCategory("icon")}/>
      </Col>
    </Form.Group>

    {mode === MODE_EDIT && <Form.Group as={Row} className="mb-2" controlId="category-editor-active">
      <Form.Label column sm={3}>{t("category_editor_field_active")}</Form.Label>
      <Col sm={9}>
        <Checkbox
          id="category-editor-active"
          checked={editedCategory.active}
          onChange={updateEditedCategory("active")}
        />
      </Col>
    </Form.Group>}

    <DeleteModal
      show={deleteConfirmationModal}
      title={t("modal_delete_title")}
      cancelLabel={t("modal_delete_button_cancel")}
      submitLabel={t("modal_delete_button_apply")}
      onCancel={hideDeleteConfirmationModal}
      onSubmit={onDeleteCategory}
    >
      {t("modal_delete_body")}
    </DeleteModal>

    <AppModal
      show={deleteWarningModal}
      title={t("modal_delete_warning_title")}
      submitLabel={t("modal_delete_warning_button_apply")}
      onSubmit={hideDeleteWarningModal}
    >
      {deleteWarningModalMessage}
    </AppModal>
  </Editor>;
};
